<template>
    <div id="auction" class="pt-5">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="heading_s3 text-center">
                        <h2 class="text-warning">Danh sách đấu giá</h2>
                    </div>
                    <div class="small_divider clearfix"></div>
                </div>
            </div>
            <div class="col-md-3 col-12" v-for="(auction, index) in auctions.data" :key="`auction-${index}`">
                <div class="product_box text-center" style="margin: 15px;">
                    <div class="product_img">
                        <a :href="route('auction.show', { slug: `${auction.name}-${auction.id}`, domain: host })">
                            <img :alt="auction.name"
                                 :data-src="auction.image"
                                 :src="auction.image"
                                 lazy="loaded">
                        </a>
                    </div>
                    <div class="product_info"><h6 class="product_title">
                        <a>{{ auction.name }}</a>
                    </h6>
                        <div class="product_price">
                            {{auction.status}}
                        </div>
                        <div class="rating_wrap">
                            <div class="rating"><div class="product_rate" style="width: 100%;"></div></div>
                            <br>
                            <a v-if="canBid(auction)" :href="route('auction.show', { slug: `${auction.name}-${auction.id}`, domain: host })" class="btn btn-fill-out btn-radius">
                                <vue-countdown v-if="canBid(auction) > 1" :time="canBid(auction) * 1000" v-slot="{ days, hours, minutes, seconds }">
                                    {{ days }}D, {{ hours }}H, {{ minutes }}M, {{ seconds }}S.
                                </vue-countdown>
                                <span v-else>Tham gia ngay</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <b-pagination
                v-model="currentPage"
                :total-rows="auctions.total"
                :per-page="auctions.per_page"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import VueCountdown from '@chenfengyuan/vue-countdown';
dayjs.extend(utc)
dayjs.extend(timezone)

export default {
    name: "Auction",
    props: {
        auctions: {},
        title: {
            type: String,
            default() {
                return ""
            }
        },
    },
    data () {
        return {
            currentPage: this.auctions.current_page,
            currentUrl: location.toString(),
            host: location.host
        }
    },
    components: {
        VueCountdown
    },
    methods:{
        canBid(auction) {
            const now = dayjs().unix();
            if (now > auction.end_at) {
                return false
            } else if (now < auction.end_at && now > auction.start_at) {
                return true
            } else {
                return auction.end_at - now
            }
        }
    }
}
</script>
